import { render } from "./CreateClient.vue?vue&type=template&id=bd72ad10&scoped=true"
import script from "./CreateClient.vue?vue&type=script&lang=js"
export * from "./CreateClient.vue?vue&type=script&lang=js"

import "./CreateClient.vue?vue&type=style&index=0&id=bd72ad10&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd72ad10"]])

export default __exports__